import script from "./Ranking.vue?vue&type=script&setup=true&lang=js"
export * from "./Ranking.vue?vue&type=script&setup=true&lang=js"

import "./Ranking.vue?vue&type=style&index=0&id=a1babcc0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1babcc0"]])

export default __exports__